import { useState, useCallback, useEffect } from 'react';
import { translations } from '../i18n/translations';

export const useTranslation = () => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('ui_language');
      if (saved && translations[saved]) return saved;
      
      // Detect browser language
      const browserLang = navigator.language.split('-')[0];
      if (translations[browserLang]) return browserLang;
    }
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('ui_language', language);
  }, [language]);

  const t = useCallback((key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  }, [language]);

  const changeLanguage = useCallback((newLang) => {
    if (translations[newLang]) {
      setLanguage(newLang);
    }
  }, []);

  return { t, language, changeLanguage };
};
